import React from "react";
import Map, { Layer, Marker, Source } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { demoRadar } from "../boardData";
import { DEMO_MAP_TOKEN, demoMapStyle } from "./demoBasemap";
import DemoPlaces from "./DemoPlaces";

// Preview stand-in for the Weather Radar widget's RainViewer embed: the
// sample agency's radar echoes on the offline basemap, so previews and
// generated screenshots never depend on a third-party page loading.
const HEAT = {
  "heatmap-weight": ["get", "w"],
  "heatmap-intensity": ["interpolate", ["linear"], ["zoom"], 5, 0.45, 8, 0.6, 11, 0.9],
  "heatmap-radius": ["interpolate", ["exponential", 2], ["zoom"], 5, 11, 6, 15, 8, 26, 10, 60],
  "heatmap-opacity": 0.8,
  "heatmap-color": [
    "interpolate", ["linear"], ["heatmap-density"],
    0, "rgba(0,0,0,0)", 0.06, "rgba(0,150,60,0.3)", 0.2, "rgba(0,190,0,0.7)", 0.4, "#e3e000",
    0.56, "#ff9a00", 0.72, "#ff2a00", 0.88, "#c8008c", 1, "#a0009a",
  ],
};

export default function DemoRadarMap({ lat, lng, zoom = 7 }) {
  return (
    <Map
      mapboxAccessToken={DEMO_MAP_TOKEN}
      initialViewState={{ latitude: lat, longitude: lng, zoom }}
      mapStyle={demoMapStyle()}
      style={{ width: "100%", height: "100%" }}
      attributionControl={false}
      interactive={false}
    >
      <Source id="demo-radar" type="geojson" data={demoRadar(0)}>
        <Layer id="demo-radar-heat" type="heatmap" paint={HEAT} />
      </Source>
      <DemoPlaces />
      <Marker latitude={lat} longitude={lng} anchor="center">
        <div className="sb-station-marker" />
      </Marker>
    </Map>
  );
}
